import CountrySelect from '../components/inputs/country_select.js';
import { api } from "../app/api.js";
import { display_errors } from "../helpers/forms.js";

export default {
    template: `
        <div class="background posters"></div>
        <div class="flexy-column">
            <div class="container">
                <h1>Register</h1>
        
                <form id="register-form" class="form">
                    <div class="input">
                        <label for="Email">Email Address</label>
                        <input type="text" id="Email" name="email" required/>
                    </div>
        
                    <div class="input">
                        <label for="Password">Password</label>
                        <input type="password" id="Password" name="password" required/>
                        <p class="hint">Password must be at least 12 characters long.</p>
                    </div>
                    
                    <div class="input">
                        <label for="PasswordConfirm">Confirm Password</label>
                        <input type="password" id="PasswordConfirm" name="password_confirm" required/>
                        <p class="error hidden">Passwords must match.</p>
                    </div>
        
                    <hr/>
                    
                    <div class="input">
                        <label for="FirstName">First Name</label>
                        <input type="text" id="FirstName" name="first_name" required/>
                    </div>
        
                    <div class="input">
                        <label for="LastName">Last Name</label>
                        <input type="text" id="LastName" name="last_name" required/>
                    </div>
                    
                    <div id="CountrySelect" class="input_wrapper"></div>
                    
                    <hr/>
        
                    <div class="input">
                        <input type="checkbox" id="TermsAgreement" name="terms_agreement" required/>
                        <label for="TermsAgreement">I have read and agree to the <a href="/terms">terms and conditions</a></label>
                    </div>
        
                    <div class="input">
                        <input type="checkbox" id="MarketingConsent" name="marketing_consent"/>
                        <label for="MarketingConsent">I would like to receive marketing and promotional emails</label>
                    </div>
        
                    <button id="RegisterSubmit" type="submit">Submit</button>
                    <div id="RegisterErrors" class="errors hidden"></div>
                </form>
                
                <div id="register-complete" class="form hidden">
                    <p>We have emailed you to confirm your account</p>
                    <p>Please confirm your email to continue</p>
                </div>
            </div>
        </div>
    `,

    $form: null,
    $errors: null,
    $submit: null,


    submit(e) {
        e.preventDefault();

        this.$errors.classList.add('hidden');
        this.$errors.textContent = '';

        let errors = {};

        const password = this.$form.password.value;
        const passwordConfirm = this.$form.password_confirm.value;
        if (password !== passwordConfirm) {
            errors['password_confirm'] = 'Passwords do not match';
        }

        if (Object.keys(errors).length > 0) {
            display_errors(this.$errors, {errors: errors}, this.$form);
            return;
        }

        api.post({
            url: '/auth/register',
            data: {
                email: this.$form.email.value,
                password: password,
                first_name: this.$form.first_name.value,
                last_name: this.$form.last_name.value,
                country_code: this.$form.country.value,
                terms_agreement: this.$form.terms_agreement.checked,
                marketing_consent: this.$form.marketing_consent.checked,
            },
            success: (response) => {
                this.$form.classList.add('hidden');
                const $complete = document.getElementById('register-complete');
                $complete.classList.remove('hidden');

                const urlParams = new URLSearchParams(window.location.search);
                const redirect = urlParams.get('redirect');

                if (redirect) {
                    const $login_link = document.getElementById('LoginLink');
                    if ($login_link) {
                        $login_link.setAttribute('href', `/login?redirect=${encodeURIComponent(redirect)}`);
                    }
                }
            },
            error: (response) => {
                display_errors(this.$errors, response, this.$form);
            }
        })
    },

    check_password(){
        if (this.$form.password.value.length < 12) {
            this.$form.password.classList.add('error');
        } else {
            this.$form.password.classList.remove('error');
        }

        if (this.$form.password.value !== this.$form.password_confirm.value && this.$form.password_confirm.value !== '') {
            this.$form.password_confirm.classList.add('error');
        } else {
            this.$form.password_confirm.classList.remove('error');
        }
    },

    _boundSubmit: null,
    _boundCheckPassword: null,

    onMount() {
        this.$form = document.getElementById('register-form');
        this.$errors = document.getElementById('RegisterErrors');
        const $country_container = document.getElementById('CountrySelect');
        const countrySelect = CountrySelect({
            id: 'Country',
            value: '',
            default_hide: true,
            onChange: (selected) => {
                console.log('Selected country:', selected);
            }
        });

        $country_container.appendChild(countrySelect.render());

        this._boundSubmit = this.submit.bind(this);
        this.$form.addEventListener('submit', this._boundSubmit);

        this._boundCheckPassword = this.check_password.bind(this);
        this.$form.password.addEventListener('input', this._boundCheckPassword);
        this.$form.password_confirm.addEventListener('input', this._boundCheckPassword);
    },

    onUnmount() {
        if (this.$form && this._boundSubmit) this.$form.removeEventListener('submit', this._boundSubmit);
        if (this.$form && this._boundCheckPassword) {
            this.$form.password.removeEventListener('input', this._boundCheckPassword);
            this.$form.password_confirm.removeEventListener('input', this._boundCheckPassword);
        }
    },
}
